import { ToastrService } from 'ngx-toastr';
import { of, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { RecordService } from '../services';
import { State } from '../services/work.state';

export const getNewRecord = (recordSvc: RecordService, toastr: ToastrService) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (state.system?.getNewRecord) {
        if (
          currentState.master?.recordId !== undefined &&
          currentState.master?.recordId > 0
        ) {
          toastr.error('Record already selected');

          const newState = {
            ...state,
            ...{
              system: {
                ...state.system,
                ...{
                  getNewRecord: false,
                },
              },
            },
          };
          return of([newState, currentState] as [Partial<State>, State]);
        } else {
          return recordSvc.getNewRecord$(state.master?.campaignId!).pipe(
            map(
              (recordId) =>
                [
                  {
                    ...state,
                    master: {
                      ...state.master,
                      ...{
                        recordId,
                      },
                    },
                    action: {
                      ...state.action,
                      ...{
                        attempt: -1,
                      },
                    },
                    ...{
                      system: {
                        ...state.system,
                        ...{
                          getNewRecord: false,
                        },
                      },
                    },
                  },
                  currentState,
                ] as [Partial<State>, State]
            )
          );
        }
      }

      return of([state, currentState] as [Partial<State>, State]);
    })
  );
